import React from 'react';
import { cx } from '../lib/hooks';
import type { SceneToken } from '../scene/TokenObject';
import { TokenText } from './TokenText';
type Props = {
  tokens: SceneToken[];
  neutral: boolean;
  wide: boolean;
  reason: string;
  onRetry?: () => void;
};

/** The token row without WebGL, so the explainer still reads when 3D can't run. */
export function FlatScene({
  tokens,
  neutral,
  wide,
  reason,
  onRetry
}: Props) {
  return <div className={cx('absolute inset-0 flex flex-col items-center gap-6 px-6', wide ? 'justify-center' : 'justify-start pt-[140px]')} data-id="element-196" data-mp="3taopsslak9yl">
      <div className={cx('flex flex-wrap justify-center', neutral ? 'gap-1' : 'gap-2.5')} data-id="element-197" data-mp="71nfqgjbjsx7">
        {tokens.map(t => <div key={t.key} className="flex h-12 items-center rounded-xl px-4 text-[18px] font-semibold text-[#0B0C12] shadow-[inset_0_-3px_0_rgba(0,0,0,0.18),0_14px_30px_-14px_rgba(0,0,0,0.9)] transition-colors duration-500" style={{
        backgroundColor: neutral ? '#D3D6E2' : t.color
      }} data-id="element-198" data-mp="b4tmrqe99o4q">
            {neutral ? <span className="font-mono" data-id="element-199" data-mp="2pkj55l6d32hv">{t.text.trim()}</span> : <TokenText text={t.text} data-id="element-200" data-mp="2pighv8wlfngu" />}
          </div>)}
      </div>
      <div className="max-w-sm text-center" data-id="element-201" data-mp="2kn9i2c6g32x7">
        <p className="text-[13px] leading-5 text-[#9A9FB0]" data-id="element-202" data-mp="2gkcv699vgkng">
          The 3D view couldn't run here, so this is a flat version.
        </p>
        <p className="mt-1 font-mono text-[11px] leading-4 text-[#5D6272]" data-id="element-203" data-mp="2blt7o4fmr0sz">{reason}</p>
        {onRetry && <button type="button" onClick={onRetry} className="mt-3 h-8 rounded-full border border-white/[0.08] bg-white/[0.04] px-3 text-[12px] font-medium text-[#9A9FB0] transition-colors hover:bg-white/[0.08] hover:text-[#EDEEF2]" data-id="element-204" data-mp="26rp1voi3oyth">
            Try the 3D view again
          </button>}
      </div>
    </div>;
}